import { useUserNotifications } from 'app/components/user-notifications/useUserNotifications'
import { UserNotificationsShadcnComponent } from 'app/components/user-notifications/UserNotificationsShadcnComponent'

export const shouldRevalidate = () => false

export default function DetailView() {
  const hookData = useUserNotifications()
  return <UserNotificationsShadcnComponent {...hookData} />
}
